import React, { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import CustomerLogApi from 'api/faber/CustomerLogAPI'
import MUIDataGrid from 'common/AbstractDataGrid/DataGridMUI'
import { generateColumnHeader } from 'helpers/column-generator/generateColumnHeader'
import { SMART_DELAY_LOG } from 'helpers/column-generator/generateColumnHeader'
import { SmartDelayFormLogType } from 'types/api/faber/customerAuditLog.type'
import { SubscriptionsTableRows } from 'types/api/faber/subscription.type'

function SmartDelayFormLogsV2({
  faberToken,
  customerRow,
  expanded,
  isExternal
}: SmartDelayProps) {
  const [rows, setRows] = useState<SmartDelayFormRows[]>([])
  const smartDelayColumns = generateColumnHeader(SMART_DELAY_LOG)

  const { isLoading: isCustomerDataLoading, refetch: refetchData } = useQuery(
    ['getCustomerForms', customerRow.userID, faberToken],
    async () => {
      const allForms = await 
      (isExternal ? 
      CustomerLogApi.getExternalSmartDelayForms(
        customerRow.userID,
        faberToken)
        :
      CustomerLogApi.getSmartDelayForms(
        customerRow.userID,
        faberToken))
      return allForms.data
    },
    {
      onSuccess: (res) => {
        if (res && res.data) {
          const formattedData: SmartDelayFormRows[] = res.data.map(
            ({
              _id,
              flightDetails,
              smartDelayId,
              createdAt
            }: SmartDelayFormLogType) => {
              return {
                formId: _id,
                mainPassengerFirstName:
                  flightDetails.main_passenger['first_name'] ??
                  flightDetails.main_passenger['first_name'],
                mainPassengerLastName:
                  flightDetails.main_passenger['last_name'] ??
                  flightDetails.main_passenger['last_name'],
                mainPassengerEmail: flightDetails.main_passenger.email,
                departureDate: flightDetails.departure_datetime_utc,
                arrivalAirportCode: flightDetails.arrival_airport_code,
                arrivalAirportNameCountry: `${flightDetails.arrival_airport_country}| ${flightDetails.arrival_airport_name}`,
                departureAirportCode: flightDetails.departure_airport_code,
                departureAirportNameCountry: `${flightDetails.departure_airport_country}| ${flightDetails.departure_airport_name}`,
                flightCode: flightDetails.flight_code,
                morePassengersDetails: flightDetails.additional_passengers,
                smartDelayId,
                createdAt,
                faberToken
              }
            }
          )
          setRows(formattedData)
        }
      },
      onError: () => {
        setRows([])
      },
      enabled: !!customerRow.userID && expanded === 'panel6'
    }
  )

  useEffect(() => {
    refetchData()
  }, [])

  return (
    <>
      <MUIDataGrid
        loading={isCustomerDataLoading}
        rowHeight={100}
        columns={smartDelayColumns}
        rows={rows}
        tableHeight='300px'
        getRowId={(row: SmartDelayFormRows) => row.formId}
      />
    </>
  )
}

export default SmartDelayFormLogsV2

interface SmartDelayProps {
  faberToken: string
  customerRow: SubscriptionsTableRows
  expanded: string | false
  isExternal: boolean
}

export interface SmartDelayFormRows {
  formId: string
  mainPassengerFirstName: string
  mainPassengerLastName: string
  mainPassengerEmail: string
  departureDate: string
  arrivalAirportCode: string
  arrivalAirportNameCountry: string
  departureAirportCode: string
  departureAirportNameCountry: string
  flightCode: string
  smartDelayId: string
  createdAt: string
  morePassengersDetails: {
    firstname?: string
    lastname?: string
  }[],
  faberToken: string
}
